// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sso-login-error-container {
    min-height: 100%;
    background-attachment: fixed;
    background-image: url("/assets/images/background-pattern.svg"), linear-gradient(rgb(0, 158, 218), rgb(0, 124, 190));
    height: 100%;
    overflow: auto;
  }
  .sso-login-error-container .container {
    padding-bottom: 50px;
  }

  #nice-img {
    width: 100px;
    height: 70px;
    padding-top: 30px;
    margin-left: auto;
    margin-right: auto;
    display: block;
  }

  #status-failed{
    padding-top: 23px;
    padding-bottom: 15px;
  }

  #status-failed-img {
    width: 64px;
    height: 64px;
    margin-left: auto;
    margin-right: auto;
    display: block;
  }

  #sso-login-error-title {
    padding-bottom: 10px;
  }

  #sso-login-error-title-p {
    text-align: center;
    min-height: 48px;
    height: auto;
    max-height: 72px;
    margin: 0;
    display : flex;
    align-items : center;
    justify-content : center;
    font-size : 18px;
    font-weight: 600;
  }

  #sso-login-error-message {
    padding-bottom: 10px;
  }

  #sso-login-error-message-p {
    text-align: center;
    min-height: 38px;
    height: auto;
    max-height: 57px;
    margin: 0;
    display : flex;
    align-items : center;
    justify-content : center;
    font-size : 13px;
    font-weight : normal;
  }

  #btnLoginToESP{
    margin:0;
    font-family: "Open Sans";
    font-size: 14px;
    border-radius: 3px;
    text-decoration: none;
    box-sizing: border-box;
    min-width: 110px;
    height: 40px;
  }

  .card {
    margin-top: 24px;
    min-height: 284px;
    height: auto;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 50px;
  }

  footer.copyRight-contactUs {
    color: #fff;
    text-align: center;
    width: 100%;
    display: block;
    padding: 0;
    margin: -50px auto 0;
    height: 50px;
  }

  .vertical-center {
    min-height: 100%;  /* Fallback for vh unit */
    min-height: 100vh; /* You might also want to use
                          'height' property instead.

                          Note that for percentage values of
                          'height' or 'min-height' properties,
                          the 'height' of the parent element
                          should be specified explicitly.

                          In this case the parent of '.vertical-center'
                          is the <body> element */

    /* Make it a flex container */
    display: flex;

    /* Align the bootstrap's container vertically */
    align-items : center;

    /* In legacy web browsers such as Firefox 9
       we need to specify the width of the flex container */
    width: 100%;

    /* Also 'margin: 0 auto' doesn't have any effect on flex items in such web browsers
       hence the bootstrap's container won't be aligned to the center anymore.

       Therefore, we should use the following declarations to get it centered again */
    justify-content : center;
  }
`, "",{"version":3,"sources":["webpack://./src/app/pages/sso-login-error/sso-login-error.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,4BAA4B;IAC5B,mHAAmH;IACnH,YAAY;IACZ,cAAc;EAChB;EACA;IACE,oBAAoB;EACtB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,cAAc;IACd,oBAAoB;IACpB,wBAAwB;IACxB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,cAAc;IACd,oBAAoB;IACpB,wBAAwB;IACxB,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,QAAQ;IACR,wBAAwB;IACxB,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,UAAU;IACV,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,gBAAgB,GAAG,yBAAyB;IAC5C,iBAAiB,EAAE;;;;;;;;;iDAS0B;;IAE7C,6BAA6B;IAK7B,aAAa;;IAEb,+CAA+C;IAK/C,oBAAoB;;IAEpB;2DACuD;IACvD,WAAW;;IAEX;;;qFAGiF;IAKjF,wBAAwB;EAC1B","sourcesContent":[".sso-login-error-container {\n    min-height: 100%;\n    background-attachment: fixed;\n    background-image: url(\"/assets/images/background-pattern.svg\"), linear-gradient(rgb(0, 158, 218), rgb(0, 124, 190));\n    height: 100%;\n    overflow: auto;\n  }\n  .sso-login-error-container .container {\n    padding-bottom: 50px;\n  }\n\n  #nice-img {\n    width: 100px;\n    height: 70px;\n    padding-top: 30px;\n    margin-left: auto;\n    margin-right: auto;\n    display: block;\n  }\n\n  #status-failed{\n    padding-top: 23px;\n    padding-bottom: 15px;\n  }\n\n  #status-failed-img {\n    width: 64px;\n    height: 64px;\n    margin-left: auto;\n    margin-right: auto;\n    display: block;\n  }\n\n  #sso-login-error-title {\n    padding-bottom: 10px;\n  }\n\n  #sso-login-error-title-p {\n    text-align: center;\n    min-height: 48px;\n    height: auto;\n    max-height: 72px;\n    margin: 0;\n    display : flex;\n    align-items : center;\n    justify-content : center;\n    font-size : 18px;\n    font-weight: 600;\n  }\n\n  #sso-login-error-message {\n    padding-bottom: 10px;\n  }\n\n  #sso-login-error-message-p {\n    text-align: center;\n    min-height: 38px;\n    height: auto;\n    max-height: 57px;\n    margin: 0;\n    display : flex;\n    align-items : center;\n    justify-content : center;\n    font-size : 13px;\n    font-weight : normal;\n  }\n\n  #btnLoginToESP{\n    margin:0;\n    font-family: \"Open Sans\";\n    font-size: 14px;\n    border-radius: 3px;\n    text-decoration: none;\n    box-sizing: border-box;\n    min-width: 110px;\n    height: 40px;\n  }\n\n  .card {\n    margin-top: 24px;\n    min-height: 284px;\n    height: auto;\n    margin-left: auto;\n    margin-right: auto;\n    margin-bottom: 50px;\n  }\n\n  footer.copyRight-contactUs {\n    color: #fff;\n    text-align: center;\n    width: 100%;\n    display: block;\n    padding: 0;\n    margin: -50px auto 0;\n    height: 50px;\n  }\n\n  .vertical-center {\n    min-height: 100%;  /* Fallback for vh unit */\n    min-height: 100vh; /* You might also want to use\n                          'height' property instead.\n\n                          Note that for percentage values of\n                          'height' or 'min-height' properties,\n                          the 'height' of the parent element\n                          should be specified explicitly.\n\n                          In this case the parent of '.vertical-center'\n                          is the <body> element */\n\n    /* Make it a flex container */\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n\n    /* Align the bootstrap's container vertically */\n    -webkit-box-align : center;\n    -webkit-align-items : center;\n    -moz-box-align : center;\n    -ms-flex-align : center;\n    align-items : center;\n\n    /* In legacy web browsers such as Firefox 9\n       we need to specify the width of the flex container */\n    width: 100%;\n\n    /* Also 'margin: 0 auto' doesn't have any effect on flex items in such web browsers\n       hence the bootstrap's container won't be aligned to the center anymore.\n\n       Therefore, we should use the following declarations to get it centered again */\n    -webkit-box-pack : center;\n    -moz-box-pack : center;\n    -ms-flex-pack : center;\n    -webkit-justify-content : center;\n    justify-content : center;\n  }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
